module.exports = __webpack_public_path__ + "static/img/jpg.e2386478.png";